import { create } from 'zustand';

interface AppStorage {
  isDoingRequest: boolean;
  doingRequest: () => void;
  requestFinalized: () => void;
}

export const useAppStorage = create<AppStorage>()((set) => ({
  isDoingRequest: false,
  doingRequest: () => set({ isDoingRequest: true }),
  requestFinalized: () => set({ isDoingRequest: false })
}));
